<script>
import Swal from "sweetalert2";
import SlTypeModal from "@/components/modals/sl-type-modal.vue";
import SlTypeCategoryModal from "@/components/modals/sl-type-category-modal.vue";

export default {
    components: {
        SlTypeModal,
        SlTypeCategoryModal
    },
    name: "SubsidiaryLedgerTypes",
    data() {
        return {
            categoriesData: [],
            categoriesTableBusy: false,
            categoriesCurrentPage: 1,
            categoriesPerPage: 10,
            categoriesFilter: null,
            categoriesFields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true,
                    thStyle: { width: '100px' }
                },
                {
                    key: "category",
                    label: "SL Categories",
                    sortable: true,
                },
                {
                    key: "actions",
                    label: "Actions",
                    thStyle: { width: '90px' }
                },
            ],
            typesData: [],
            typesTableBusy: false,
            typesCurrentPage: 1,
            typesPerPage: 10,
            typesFilter: null,
            typesFields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true,
                    thStyle: { width: '80px' }
                },
                {
                    key: "code",
                    label: "SL Type Code",
                    sortable: true,
                    thStyle: { width: '120px' }
                },
                {
                    key: "type",
                    label: "SL Types",
                    sortable: true,
                },
                {
                    key: "actions",
                    label: "Actions",
                    thStyle: { width: '90px' }
                },
            ],
            
            // Modal and form data
            modalTitle: "",
            indexSelected: -1,
            selectedCategoryId: 0,
            pageOptions: [10, 25, 50, 100],
        };
    },
    computed: {
        categoriesRows() {
            if(this.categoriesFilter){
                return this.categoriesData.length;
            }
            return this.categoriesData.length;
        },
        typesRows() {
            if(this.typesFilter){
                return this.typesData.length;
            }
            return this.typesData.length;
        },
    },
    methods: {
        onCategoriesFiltered(filteredItems) {
            this.categoriesCurrentPage = 1;
        },
        onTypesFiltered(filteredItems) {
            this.typesCurrentPage = 1;
        },
        async getSlCategories() {
            this.categoriesTableBusy = true;
            await this.$store
                .dispatch("sltypecategory/getSLTypeCategories")
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.categoriesData = res.data;
                })
                .catch(() => {
                    this.showToast("Error loading categories!", "error");
                });
            this.categoriesTableBusy = false;
        },
        
        onCategoryRowClick(item) {
            this.selectedCategoryId = item.id;
            this.getSlTypes(item.id);
        },
        async getSlTypes(categoryId) {
            this.typesTableBusy = true;
            await this.$store
                .dispatch("sltype/getSLTypeByCategory", categoryId)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.typesData = res.data;
                })
                .catch(() => {
                    this.showToast("Error loading types!", "error");
                });
            this.typesTableBusy = false;
        },
        
        addSlTypeCat() {
            this.$refs.slTypeCategoryModal.onReset();
            this.modalTitle = "Create New SL Category";
            this.$bvModal.show("sl-type-category-modal");
        },
        
        addSlType() {
            if (!this.selectedCategoryId) {
                this.showToast("Please select a category first!", "warning");
                return;
            }
            this.$refs.slTypeModal.onReset();
            this.modalTitle = "Create New SL Type";
            this.$bvModal.show("sl-type-modal");
        },
        
        onCreate(modalData) {
            modalData.subsidiaryLedgerTypeCategoryId = this.selectedCategoryId;
            if (modalData.id > 0) {
                this.$store.dispatch("sltype/updateSLType", modalData)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.typesData.findIndex(t => t.id === modalData.id);
                        this.typesData.splice(index, 1, modalData);
                        this.$bvModal.hide("sl-type-modal");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                this.$store.dispatch("sltype/createSLType", modalData)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.typesData.push(res.data);
                        this.$bvModal.hide("sl-type-modal");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
        onCategoryCreate(modalData) {
            if (modalData.id > 0) {
                this.$store.dispatch("sltypecategory/updateSLTypeCategory", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.categoriesData.findIndex(c => c.id === modalData.id);
                        this.categoriesData.splice(index, 1, modalData);
                        this.$bvModal.hide("sl-type-category-modal");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong!", "error");
                    })
            } else {
                this.$store.dispatch("sltypecategory/createSLTypeCategory", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.categoriesData.push(res.data);
                        this.$bvModal.hide("sl-type-category-modal");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong!", "error");
                    })
            }
        },
        
        updateSlType(props) {
            this.modalTitle = "Update SL Type";
            this.$refs.slTypeModal.updateData(props.item);
            this.$bvModal.show("sl-type-modal");
        },
        
        updateSlTypeCategory(props) {
            this.modalTitle = "Update SL Category";
            this.$refs.slTypeCategoryModal.putData(props.item);
            this.$bvModal.show("sl-type-category-modal");
        },
        
        deleteSlType(props) {
            var index = this.typesData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch("sltype/removeSLType", props.item.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            this.typesData.splice(index, 1);
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        
        deleteSlTypeCategory(props) {
            var index = this.categoriesData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch("sltypecategory/removeSLTypeCategory", props.item.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            this.categoriesData.splice(index, 1);
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        
        getCategoryRowClass(item) {
            return item ? item.id === this.selectedCategoryId ? 'table-success' : '' : '';
        },
    },
};
</script>

<template>
    <div>
        <!-- Main content -->
        <div class="row">
            <div class="col-md-12">
                <div class="card border">
                    <div class="card-body">
                        <div class="row">
                            <!-- Left side - SL Categories -->
                            <div class="col-md-6">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <div class="d-flex align-items-center">
                                        <h4 class="card-title my-0">SL Categories</h4>
                                        <button
                                            type="button"
                                            @click="addSlTypeCat()"
                                            class="btn btn-sm btn-info d-flex align-items-center"
                                        >
                                            <i class="bx bx-plus"></i>
                                        </button>
                                    </div>
                                    <div
                                        id="categories-table_filter"
                                        class="dataTables_filter text-md-end"
                                    >
                                        <label class="d-inline-flex align-items-center mb-0">
                                            Search:
                                            <b-form-input
                                                autocomplete="off"
                                                v-model="categoriesFilter"
                                                type="search"
                                                placeholder="Search categories..."
                                                class="form-control form-control-sm ms-2 me-1"
                                            ></b-form-input>
                                            <b-form-select
                                                class="form-select form-select-sm w-auto"
                                                v-model="categoriesPerPage"
                                                size="sm"
                                                :options="pageOptions"
                                            ></b-form-select>
                                        </label>
                                    </div>
                                </div>
                                
                                <div class="table-responsive mb-0">
                                    <b-table
                                        class="datatables"
                                        :items="categoriesData"
                                        :fields="categoriesFields"
                                        responsive="sm"
                                        :per-page="categoriesPerPage"
                                        :current-page="categoriesCurrentPage"
                                        :filter="categoriesFilter"
                                        :busy="categoriesTableBusy"
                                        @filtered="onCategoriesFiltered"
                                        @row-clicked="onCategoryRowClick"
                                        :tbody-tr-class="getCategoryRowClass"
                                        bordered
                                        outlined
                                        hover
                                        striped
                                        show-empty
                                        selectable
                                        select-mode="single"
                                    >
                                        <template #empty="scope">
                                            <div class="text-center">{{ scope.emptyText }}</div>
                                        </template>
                                        
                                        <template #table-busy>
                                            <div class="d-flex justify-content-center align-items-center">
                                                <div class="preloader-component me-2">
                                                    <div class="status">
                                                        <div class="spinner-border" role="status">
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <strong>Loading...</strong>
                                            </div>
                                        </template>
                                        
                                        <template #cell(actions)="row">
                                            <div class="float-end">
                                                <b-dropdown
                                                    id="dropdown-dropleft-categories"
                                                    right
                                                    variant="link"
                                                    toggle-class="text-decoration-none"
                                                    menu-class="dropdown-menu-end"
                                                    no-caret
                                                >
                                                    <template #button-content>
                                                        <i class="fas fa-ellipsis-v"></i>
                                                    </template>
                                                    <b-dropdown-item
                                                        @click="updateSlTypeCategory(row)"
                                                        variant="secondary"
                                                    >
                                                        <i class="bx bx-edit me-1"></i>Edit
                                                    </b-dropdown-item>
                                                    <b-dropdown-item
                                                        @click="deleteSlTypeCategory(row)"
                                                        variant="danger"
                                                    >
                                                        <i class="bx bx-trash me-1"></i>Delete
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                        </template>
                                    </b-table>
                                </div>
                                
                                <div class="row">
                                    <div class="col">
                                        <div class="dataTables_paginate paging_simple_numbers float-end">
                                            <ul class="pagination pagination-rounded mb-0">
                                                <b-pagination
                                                    v-model="categoriesCurrentPage"
                                                    :total-rows="categoriesRows"
                                                    :per-page="categoriesPerPage"
                                                ></b-pagination>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Right side - SL Types -->
                            <div class="col-md-6">
                                <div style="position:sticky;top:140px;">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div class="d-flex align-items-center">
                                            <h4 class="card-title my-0 me-1">SL Types</h4>
                                            <button
                                                v-if="selectedCategoryId"
                                                type="button"
                                                @click="addSlType()"
                                                class="btn btn-sm btn-info d-flex align-items-center"
                                            >
                                                <i class="bx bx-plus"></i>
                                            </button>
                                        </div>
                                        <div
                                            id="types-table_filter"
                                            class="dataTables_filter text-md-end"
                                        >
                                            <label class="d-inline-flex align-items-center mb-0">
                                                Search:
                                                <b-form-input
                                                    autocomplete="off"
                                                    v-model="typesFilter"
                                                    type="search"
                                                    placeholder="Search types..."
                                                    class="form-control form-control-sm ms-2 me-1"
                                                ></b-form-input>
                                                <b-form-select
                                                    class="form-select form-select-sm w-auto"
                                                    v-model="typesPerPage"
                                                    size="sm"
                                                    :options="pageOptions"
                                                ></b-form-select>
                                            </label>
                                        </div>
                                    </div>
                                    
                                    <div class="table-responsive mb-0">
                                        <b-table
                                            class="datatables"
                                            :items="typesData"
                                            :fields="typesFields"
                                            responsive="sm"
                                            :per-page="typesPerPage"
                                            :current-page="typesCurrentPage"
                                            :filter="typesFilter"
                                            :busy="typesTableBusy"
                                            @filtered="onTypesFiltered"
                                            bordered
                                            outlined
                                            hover
                                            striped
                                            show-empty
                                        >
                                            <template #empty="scope">
                                                <div class="text-center">
                                                    {{ scope.emptyText }}
                                                </div>
                                            </template>
                                            
                                            <template #table-busy>
                                                <div class="d-flex justify-content-center align-items-center">
                                                    <div class="preloader-component me-2">
                                                        <div class="status">
                                                            <div class="spinner-border" role="status">
                                                                <span class="sr-only">Loading...</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <strong>Loading...</strong>
                                                </div>
                                            </template>
                                            
                                            <template #cell(actions)="row">
                                                <div class="float-end">
                                                    <b-dropdown
                                                        id="dropdown-dropleft"
                                                        right
                                                        variant="link"
                                                        toggle-class="text-decoration-none"
                                                        menu-class="dropdown-menu-end"
                                                        no-caret
                                                    >
                                                        <template #button-content>
                                                            <i class="fas fa-ellipsis-v"></i>
                                                        </template>
                                                        <b-dropdown-item
                                                            @click="updateSlType(row)"
                                                            variant="secondary"
                                                        >
                                                            <i class="bx bx-edit me-1"></i>Edit
                                                        </b-dropdown-item>
                                                        <b-dropdown-item
                                                            @click="deleteSlType(row)"
                                                            variant="danger"
                                                        >
                                                            <i class="bx bx-trash me-1"></i>Delete
                                                        </b-dropdown-item>
                                                    </b-dropdown>
                                                </div>
                                            </template>
                                        </b-table>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col">
                                            <div class="dataTables_paginate paging_simple_numbers float-end">
                                                <ul class="pagination pagination-rounded mb-0">
                                                    <b-pagination
                                                        v-model="typesCurrentPage"
                                                        :total-rows="typesRows"
                                                        :per-page="typesPerPage"
                                                    ></b-pagination>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sl-type-modal
            ref="slTypeModal"
            :modal-title="modalTitle"
            @create="onCreate"
        />
        <sl-type-category-modal
            ref="slTypeCategoryModal"
            :modal-title="modalTitle"
            @dropData="onCategoryCreate"
        />
    </div>
</template>